import Button from '@jetbrains/ring-ui/components/button/button'
import ButtonGroup, {Caption} from '@jetbrains/ring-ui/components/button-group/button-group'
import classNames from 'classnames'
import * as React from 'react'

import type {Partitions} from '../../Rules.types'
import {LoadingContext, DispatchContext} from '../CleanupForm.contexts'
import styles from '../CleanupForm.css'
import type {CleanupWillApply} from '../CleanupForm.types'

type OwnProps = {
  value: CleanupWillApply | null | undefined
}
const BRANCH = 'branch'
const ALL = 'all'
export const willApplyConverter = {
  toRule: (value: CleanupWillApply, entity?: Partitions): Partitions => ({
    ...entity,
    perBranch:
      value === BRANCH
        ? {
            active: true,
          }
        : null,
  }),
  toForm: (value: Partitions | null | undefined): CleanupWillApply =>
    value == null || value.perBranch ? BRANCH : ALL,
}

function WillApplySection({value}: OwnProps) {
  const disabled = React.useContext(LoadingContext)
  const setValue = React.useContext(DispatchContext)
  const onChange = React.useCallback(
    (values: CleanupWillApply) =>
      setValue?.({
        name: 'willApply',
        value: values,
      }),
    [setValue],
  )
  const selectPerBranch = React.useCallback(() => onChange(BRANCH), [onChange])
  const selectAll = React.useCallback(() => onChange(ALL), [onChange])
  return (
    <div className={classNames(styles.row, styles.separateRow)}>
      <Caption className={styles.caption}>{'Apply rule'}</Caption>
      <div className={styles.content}>
        <div className={classNames(styles.column, styles.switch)}>
          <ButtonGroup>
            <Button disabled={disabled} active={value === BRANCH} onClick={selectPerBranch}>
              {'To each selected branch'}
            </Button>
            <Button disabled={disabled} active={value === ALL} onClick={selectAll}>
              {'To all branches as a set'}
            </Button>
          </ButtonGroup>
        </div>
        <div className={styles.hint}>
          {
            'The filters can be applied per every matching branch, or to all builds in matching branches as one set. This affects how many builds are preserved: e.g. 30 last builds in each branch or 30 last builds among all branches.'
          }
        </div>
      </div>
    </div>
  )
}

export default React.memo<OwnProps>(WillApplySection)
